var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 12,
    fill: "#081127"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 25H53.3333L56.6666 31.6667V53.3333C56.6666 53.7754 56.4911 54.1993 56.1785 54.5118C55.8659 54.8244 55.442 55 55 55H25C24.558 55 24.134 54.8244 23.8215 54.5118C23.5089 54.1993 23.3333 53.7754 23.3333 53.3333V31.6733L26.6666 25ZM41.6666 43.3333V36.6667H38.3333V43.3333H33.3333L40 50L46.6666 43.3333H41.6666ZM52.94 31.6667L51.2733 28.3333H28.7283L27.0616 31.6667H52.94Z",
    fill: "url(#paint0_linear_101_259)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_259",
    x1: 23.3333,
    y1: 28.75,
    x2: 57.1343,
    y2: 29.5632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF02C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemSold);
export default __webpack_public_path__ + "static/media/itemSold.410a353b204d244bc8d228692b99ecb9.svg";
export { ForwardRef as ReactComponent };